import Vue from 'vue'
import Vuetify from 'vuetify';

Vue.use(Vuetify);

window.Vue = Vue;

const isProduction = process.env.NODE_ENV === 'production';

import VueLogger from 'vuejs-logger';

Vue.use(VueLogger, {
    isEnabled: true,
    logLevel: isProduction ? 'error' : 'debug',
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true
});

import VueDatePicker from 'vuejs-datepicker';
import VueDatePickerDe from 'vuejs-datepicker/dist/locale/translations/de';
Vue.component('datepicker', VueDatePicker);

import VueMoment from 'vue-moment';
Vue.use(VueMoment);

import store from './store'

import './i18n'

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask);

import './fontawesome'

import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';
Vue.use(VuePlyr);

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

import VueSlider from 'vue-slider-component/src/vue2-slider';
Vue.component('vue-slider', VueSlider);

import VueCountdown from '@chenfengyuan/vue-countdown';
Vue.component(VueCountdown.name, VueCountdown);

import PageMessages from './components/PageMessages';
Vue.component('page-messages', PageMessages);

import CSRF from './components/CSRF';
Vue.component('csrf', CSRF);

import ConfirmModal from './components/ConfirmModal'
Vue.component('confirm-modal', ConfirmModal);

import SubmitOnceForm from "./components/SubmitOnceForm";
Vue.component("submit-once-form", SubmitOnceForm)

import BookingEditCreate from "./backend/components/booking/BookingEditCreate";
Vue.component('booking-edit-create', BookingEditCreate);

import EasybillPositions from "./backend/components/content/course/EasybillPositions.vue";
Vue.component('easybill-positions', EasybillPositions);

const opts = {};

import vuetify from './plugins/vuetify';

if (document.getElementById('app')) {
    const app = window.vue_app = new Vue({
        vuetify,
        el: '#app',
        components: {},
        store,
    });
}
